import { useEffect, useState } from 'react';

export default function HomePage() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('2026-01-26T19:50:00-05:00').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  const whatsappMessage = encodeURIComponent('hola, david. me gustaria inscribirme en la mentoría grupal de trading que empieza el 26 de enero del 2026');
  const whatsappLink = `https://wa.me/?text=${whatsappMessage}`;

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#070B19] via-[#0a0f1f] to-[#0d1228]">
      {/* Barra de Alerta Superior */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#006fdd] to-[#0059b3] shadow-lg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <p className="text-white text-center text-xs sm:text-sm md:text-base font-medium leading-relaxed">
            Si quieres empezar el 2026 con una operativa clara y rentable, este es el último llamado: quedan pocos cupos disponibles.
          </p>
        </div>
      </div>

      {/* Hero Section con fondo de trading */}
      <section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20 sm:pt-24 lg:pt-28 pb-12 sm:pb-16 overflow-hidden">
        {/* Fondo de trading con overlay */}
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/3dceeab31209bff0e0358a6e4a992803.jpg"
            alt="Trading Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/95 via-[#070B19]/85 to-[#070B19]/95"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#006fdd]/10 via-transparent to-[#006fdd]/10"></div>
        </div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Aprende los Criterios que Te Ayudarán a <span className="text-[#006fdd] drop-shadow-[0_0_30px_rgba(0,111,221,0.5)]">Ganar Dinero</span> en Trading
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-8 sm:mb-12 max-w-4xl mx-auto font-light px-4">
            En esta mentoría grupal aprenderás los criterios que me ayudaron a ganar $47000 en FTMO.
          </p>

          {/* Contador Regresivo */}
          <div className="mb-8 sm:mb-12">
            <p className="text-white/80 text-sm sm:text-base md:text-lg lg:text-xl mb-4 sm:mb-6 md:mb-8 font-medium px-4">La mentoría inicia en:</p>
            <div className="flex justify-center items-center gap-1 xs:gap-2 sm:gap-4 md:gap-6 lg:gap-8 flex-wrap px-2 max-w-full">
              <div className="flex flex-col items-center min-w-0">
                <div className="w-14 h-14 xs:w-16 xs:h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 bg-gradient-to-br from-[#0d1228] to-[#070B19] border-2 border-[#006fdd]/50 rounded-lg sm:rounded-xl flex items-center justify-center shadow-[0_0_30px_rgba(0,111,221,0.3)] backdrop-blur-sm">
                  <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white">{String(timeLeft.days).padStart(2, '0')}</span>
                </div>
                <span className="text-[9px] xs:text-[10px] sm:text-xs md:text-sm text-white/70 uppercase mt-1.5 sm:mt-2 md:mt-3 tracking-wider sm:tracking-widest font-semibold">Días</span>
              </div>
              <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#006fdd] font-bold leading-none">:</span>
              <div className="flex flex-col items-center min-w-0">
                <div className="w-14 h-14 xs:w-16 xs:h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 bg-gradient-to-br from-[#0d1228] to-[#070B19] border-2 border-[#006fdd]/50 rounded-lg sm:rounded-xl flex items-center justify-center shadow-[0_0_30px_rgba(0,111,221,0.3)] backdrop-blur-sm">
                  <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white">{String(timeLeft.hours).padStart(2, '0')}</span>
                </div>
                <span className="text-[9px] xs:text-[10px] sm:text-xs md:text-sm text-white/70 uppercase mt-1.5 sm:mt-2 md:mt-3 tracking-wider sm:tracking-widest font-semibold">Horas</span>
              </div>
              <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#006fdd] font-bold leading-none">:</span>
              <div className="flex flex-col items-center min-w-0">
                <div className="w-14 h-14 xs:w-16 xs:h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 bg-gradient-to-br from-[#0d1228] to-[#070B19] border-2 border-[#006fdd]/50 rounded-lg sm:rounded-xl flex items-center justify-center shadow-[0_0_30px_rgba(0,111,221,0.3)] backdrop-blur-sm">
                  <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white">{String(timeLeft.minutes).padStart(2, '0')}</span>
                </div>
                <span className="text-[9px] xs:text-[10px] sm:text-xs md:text-sm text-white/70 uppercase mt-1.5 sm:mt-2 md:mt-3 tracking-wider sm:tracking-widest font-semibold">Minutos</span>
              </div>
              <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#006fdd] font-bold leading-none">:</span>
              <div className="flex flex-col items-center min-w-0">
                <div className="w-14 h-14 xs:w-16 xs:h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 bg-gradient-to-br from-[#0d1228] to-[#070B19] border-2 border-[#006fdd]/50 rounded-lg sm:rounded-xl flex items-center justify-center shadow-[0_0_30px_rgba(0,111,221,0.3)] backdrop-blur-sm">
                  <span className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white">{String(timeLeft.seconds).padStart(2, '0')}</span>
                </div>
                <span className="text-[9px] xs:text-[10px] sm:text-xs md:text-sm text-white/70 uppercase mt-1.5 sm:mt-2 md:mt-3 tracking-wider sm:tracking-widest font-semibold">Segundos</span>
              </div>
            </div>
          </div>

          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-[#006fdd] to-[#0059b3] text-white text-sm sm:text-base md:text-lg font-bold rounded-full hover:scale-105 hover:shadow-[0_0_40px_rgba(0,111,221,0.6)] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
            Quiero unirme a la Mentoría
          </a>
          
          <p className="text-white/60 text-xs sm:text-sm mt-4 sm:mt-6 px-4">
            Mentoría grupal — Cupo máximo 20 traders
          </p>
        </div>
      </section>

      {/* Fecha & Modalidad */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0 opacity-5">
          <img 
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20trading%20chart%20pattern%20with%20candlesticks%20and%20technical%20analysis%20lines%20on%20black%20background%20with%20subtle%20blue%20glow%20minimal%20professional%20forex%20market%20data%20visualization&width=1920&height=600&seq=section-bg-002&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container mx-auto max-w-7xl relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-gradient-to-br from-[#0d1228]/90 to-[#070B19]/90 backdrop-blur-sm border border-[#006fdd]/30 rounded-2xl p-6 sm:p-8 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] hover:border-[#006fdd]/60 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_20px_rgba(0,111,221,0.4)]">
                <i className="ri-calendar-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white text-center mb-3 sm:mb-4">Inicio</h3>
              <p className="text-sm sm:text-base text-white/80 text-center leading-relaxed">
                26 de enero del 2026<br/>
                Lunes y martes<br/>
                19:50 a 21:00 (GMT-5)
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#0d1228]/90 to-[#070B19]/90 backdrop-blur-sm border border-[#006fdd]/30 rounded-2xl p-6 sm:p-8 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] hover:border-[#006fdd]/60 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_20px_rgba(0,111,221,0.4)]">
                <i className="ri-video-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white text-center mb-3 sm:mb-4">Modalidad</h3>
              <p className="text-sm sm:text-base text-white/80 text-center leading-relaxed">
                Clases en vivo + grabaciones en la academia
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#0d1228]/90 to-[#070B19]/90 backdrop-blur-sm border border-[#006fdd]/30 rounded-2xl p-6 sm:p-8 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] hover:border-[#006fdd]/60 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_20px_rgba(0,111,221,0.4)]">
                <i className="ri-gift-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white text-center mb-3 sm:mb-4">Beneficios</h3>
              <p className="text-sm sm:text-base text-white/80 text-center leading-relaxed">
                Comunidad VIP, proyecciones y análisis de mercado en vivo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Lo que Aprenderás */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=dark%20professional%20trading%20workspace%20with%20multiple%20monitors%20showing%20forex%20charts%20technical%20indicators%20and%20market%20analysis%20tools%20with%20blue%20ambient%20lighting%20clean%20modern%20setup%20minimal%20background&width=1920&height=1200&seq=learning-bg-003&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/95 via-[#070B19]/90 to-[#070B19]/95"></div>
        </div>
        <div className="container mx-auto max-w-7xl relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-10 sm:mb-12 md:mb-16 px-4">
            Lo que Aprenderás
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            {/* Módulo 1 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 1</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Estructura de Mercado (HTF & LTF)</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>HL, HH, LH, LL, BOS</span>
                </li>
              </ul>
            </div>

            {/* Módulo 2 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 2</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Análisis Fundamental Institucional</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Niveles fundamentales del precio</span>
                </li>
              </ul>
            </div>

            {/* Módulo 3 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 3</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Liquidez</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Máximos iguales, mínimos iguales y zonas sensibles</span>
                </li>
              </ul>
            </div>

            {/* Módulo 4 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 4</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Criterios de Inversión Institucional</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Strong zones y zonas de stop hunt</span>
                </li>
              </ul>
            </div>

            {/* Módulo 5 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 5</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Gestión de Riesgo Profesional</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Ratios beneficio — pérdida simétrica</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Incluye indicador de gestión de riesgo <span className="ml-2 text-xs bg-[#006fdd] px-2 py-1 rounded-md shadow-[0_0_10px_rgba(0,111,221,0.4)]">INCLUYE</span></span>
                </li>
              </ul>
            </div>

            {/* Módulo 6 */}
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 md:p-7 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] hover:translate-y-[-4px] transition-all duration-300">
              <span className="text-[#006fdd] text-xs sm:text-sm font-bold tracking-wider">MÓDULO 6</span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-2 mb-3 sm:mb-4">Análisis de Mercado en Vivo</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Sesiones reales de lectura del precio</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-white/85">
                  <span className="w-2 h-2 bg-[#006fdd] rounded-sm mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(0,111,221,0.6)]"></span>
                  <span>Incluye indicador de sesiones en MT4 <span className="ml-2 text-xs bg-[#006fdd] px-2 py-1 rounded-md shadow-[0_0_10px_rgba(0,111,221,0.4)]">INCLUYE</span></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* NUEVA SECCIÓN: Antes y Después - Transforma tu Trading en 2026 */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        {/* Fondo con overlay */}
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=dramatic%20transformation%20concept%20showing%20dark%20chaotic%20trading%20charts%20transitioning%20to%20organized%20profitable%20trading%20setup%20with%20blue%20and%20gold%20lighting%20professional%20forex%20market%20evolution%20from%20loss%20to%20success%20minimal%20modern%20aesthetic&width=1920&height=1400&seq=transformation-bg-009&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/96 via-[#070B19]/94 to-[#070B19]/96"></div>
        </div>

        {/* Elementos decorativos */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-red-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-[#006fdd]/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto max-w-7xl relative z-10">
          {/* Título principal */}
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <div className="inline-block bg-gradient-to-r from-red-500/20 to-[#006fdd]/20 backdrop-blur-sm border border-red-500/30 rounded-full px-6 py-2 mb-6">
              <p className="text-sm sm:text-base text-white/90 font-semibold">
                ¿Te identificas con alguno de estos problemas?
              </p>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 px-4 leading-tight">
              Transforma tu Trading en <span className="text-[#006fdd] drop-shadow-[0_0_30px_rgba(0,111,221,0.6)]">2026</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto px-4 leading-relaxed">
              Del caos y las pérdidas a la consistencia y rentabilidad. Descubre cómo esta mentoría te llevará al siguiente nivel.
            </p>
          </div>

          {/* Grid de Antes y Después */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 mb-12 sm:mb-16">
            {/* Columna ANTES - Problemas */}
            <div className="space-y-4 sm:space-y-5">
              <div className="text-center lg:text-left mb-6 sm:mb-8">
                <div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-500/30 to-red-600/30 backdrop-blur-sm border-2 border-red-500/50 rounded-2xl px-6 sm:px-8 py-3 sm:py-4 shadow-[0_0_30px_rgba(239,68,68,0.3)]">
                  <i className="ri-close-circle-fill text-2xl sm:text-3xl text-red-400"></i>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white">ANTES</h3>
                </div>
              </div>

              {/* Problema 1 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-emotion-unhappy-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Ausencia de Gestión Emocional</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Operas por impulso, dejas que el miedo y la codicia controlen tus decisiones. Cada pérdida te afecta emocionalmente.
                    </p>
                  </div>
                </div>
              </div>

              {/* Problema 2 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-funds-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Gestión de Riesgo Deficiente</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      No entiendes cómo funciona una gestión de riesgo simétrica. Arriesgas demasiado en cada operación sin un plan claro.
                    </p>
                  </div>
                </div>
              </div>

              {/* Problema 3 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-bar-chart-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Sin Ratios Beneficio-Pérdida Definidos</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Entras y sales del mercado sin objetivos claros. No sabes cuándo tomar ganancias o cortar pérdidas.
                    </p>
                  </div>
                </div>
              </div>

              {/* Problema 4 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-close-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Semana de Trading Desorganizada</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Operas sin planificación. No tienes una rutina establecida ni sabes qué días son mejores para operar.
                    </p>
                  </div>
                </div>
              </div>

              {/* Problema 5 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-stack-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Operas Demasiados Pares</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Intentas seguir 10+ pares simultáneamente. Te dispersas y pierdes oportunidades de calidad por falta de enfoque.
                    </p>
                  </div>
                </div>
              </div>

              {/* Problema 6 */}
              <div className="group bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-md border-l-4 border-red-500 rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-focus-line text-xl sm:text-2xl text-red-400"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Ausencia Total de Enfoque</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Saltas de estrategia en estrategia. Buscas el "santo grial" en lugar de dominar una metodología probada.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Columna DESPUÉS - Soluciones */}
            <div className="space-y-4 sm:space-y-5">
              <div className="text-center lg:text-left mb-6 sm:mb-8">
                <div className="inline-flex items-center gap-3 bg-gradient-to-r from-[#006fdd]/30 to-[#0059b3]/30 backdrop-blur-sm border-2 border-[#006fdd]/50 rounded-2xl px-6 sm:px-8 py-3 sm:py-4 shadow-[0_0_30px_rgba(0,111,221,0.4)]">
                  <i className="ri-checkbox-circle-fill text-2xl sm:text-3xl text-[#006fdd]"></i>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white">DESPUÉS</h3>
                </div>
              </div>

              {/* Solución 1 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mental-health-line text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Mentalidad Operativa Fortalecida</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Operas con disciplina y control emocional. Entiendes que el trading es un juego de probabilidades y actúas en consecuencia.
                    </p>
                  </div>
                </div>
              </div>

              {/* Solución 2 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Gestión de Riesgo Profesional</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Dominas la gestión de riesgo simétrica. Proteges tu capital y maximizas ganancias con ratios beneficio-pérdida claros.
                    </p>
                  </div>
                </div>
              </div>

              {/* Solución 3 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-fill text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Objetivos y Ratios Definidos</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Cada operación tiene un plan claro: entrada, stop loss y take profit. Sabes exactamente cuánto arriesgas y cuánto puedes ganar.
                    </p>
                  </div>
                </div>
              </div>

              {/* Solución 4 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-check-line text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Rutina de Trading Estructurada</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Tienes una semana de trading organizada. Sabes qué sesiones operar, cuándo analizar y cuándo descansar.
                    </p>
                  </div>
                </div>
              </div>

              {/* Solución 5 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-focus-3-line text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Enfoque en Pares Selectos</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Te especializas en 2-3 pares clave. Conoces su comportamiento a profundidad y aprovechas las mejores oportunidades.
                    </p>
                  </div>
                </div>
              </div>

              {/* Solución 6 */}
              <div className="group bg-gradient-to-br from-[#006fdd]/10 to-[#0059b3]/5 backdrop-blur-md border-l-4 border-[#006fdd] rounded-xl p-5 sm:p-6 hover:shadow-[0_0_30px_rgba(0,111,221,0.3)] transition-all duration-300">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#006fdd]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-flash-line text-xl sm:text-2xl text-[#006fdd]"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Metodología Clara y Probada</h4>
                    <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                      Dominas una estrategia institucional comprobada. Operas con confianza basándote en criterios sólidos y repetibles.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Flecha de transformación (visible en desktop) */}
          <div className="hidden lg:flex items-center justify-center my-8 sm:my-12">
            <div className="flex items-center gap-4">
              <div className="w-16 h-1 bg-gradient-to-r from-red-500 to-[#006fdd]"></div>
              <div className="w-16 h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center shadow-[0_0_40px_rgba(0,111,221,0.6)]">
                <i className="ri-arrow-right-line text-3xl text-white"></i>
              </div>
              <div className="w-16 h-1 bg-gradient-to-r from-[#006fdd] to-[#0059b3]"></div>
            </div>
          </div>

          {/* CTA Final de la sección */}
          <div className="bg-gradient-to-br from-[#006fdd]/20 to-[#0059b3]/20 backdrop-blur-xl border-2 border-[#006fdd]/40 rounded-3xl p-8 sm:p-10 md:p-12 text-center shadow-[0_0_60px_rgba(0,111,221,0.3)] mt-12 sm:mt-16">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6 px-2">
              Haz del 2026 tu Año de <span className="text-[#006fdd] drop-shadow-[0_0_20px_rgba(0,111,221,0.8)]">Transformación</span>
            </h3>
            <p className="text-base sm:text-lg md:text-xl text-white/85 max-w-3xl mx-auto mb-8 sm:mb-10 leading-relaxed px-4">
              No sigas operando con los mismos errores. Esta mentoría te dará las herramientas, la mentalidad y el acompañamiento que necesitas para convertirte en un trader consistente y rentable.
            </p>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 sm:px-10 md:px-12 py-4 sm:py-5 bg-gradient-to-r from-[#006fdd] to-[#0059b3] text-white text-base sm:text-lg md:text-xl font-bold rounded-full hover:scale-105 hover:shadow-[0_0_50px_rgba(0,111,221,0.7)] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl sm:text-3xl"></i>
              Quiero Transformar mi Trading
            </a>
            <p className="text-white/50 text-xs sm:text-sm mt-4 sm:mt-6 px-4">
              Solo quedan 7 cupos disponibles • Inicia el 26 de enero 2026
            </p>
          </div>
        </div>
      </section>

      {/* Objetivo de la Mentoría */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=successful%20trader%20analyzing%20profitable%20forex%20charts%20on%20large%20monitors%20in%20modern%20dark%20office%20with%20blue%20accent%20lights%20showing%20upward%20trending%20market%20data%20and%20financial%20success%20professional%20trading%20setup&width=1920&height=800&seq=objective-bg-004&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="bg-gradient-to-br from-[#006fdd]/20 to-[#0059b3]/20 backdrop-blur-xl border border-[#006fdd]/40 rounded-2xl sm:rounded-3xl p-8 sm:p-12 md:p-16 text-center shadow-[0_0_60px_rgba(0,111,221,0.3)]">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6 px-2">
              <span className="text-[#006fdd] text-4xl sm:text-5xl drop-shadow-[0_0_20px_rgba(0,111,221,0.8)]">"</span>
              Entrena como un trader profesional y construye una operativa rentable para el 2026
              <span className="text-[#006fdd] text-4xl sm:text-5xl drop-shadow-[0_0_20px_rgba(0,111,221,0.8)]">"</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed px-2">
              Mejorar hábitos, fortalecer mentalidad operativa, entender criterios institucionales y aprender a gestionar cuentas personales de $500–$1000 y lograr aprobar retos de fondeo.
            </p>
          </div>
        </div>
      </section>

      {/* Comunidad VIP */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=professional%20trading%20community%20workspace%20with%20multiple%20screens%20showing%20live%20market%20analysis%20and%20trading%20charts%20dark%20modern%20office%20with%20blue%20lighting%20collaborative%20forex%20trading%20environment&width=1920&height=1000&seq=community-bg-005&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/92 via-[#070B19]/88 to-[#070B19]/92"></div>
        </div>
        <div className="container mx-auto max-w-7xl relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-10 sm:mb-12 md:mb-16 px-4">
            Comunidad VIP
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-t-4 border-[#006fdd] rounded-2xl p-6 sm:p-8 text-center hover:shadow-[0_0_40px_rgba(0,111,221,0.4)] hover:translate-y-[-6px] transition-all duration-300">
              <div className="w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_25px_rgba(0,111,221,0.5)]">
                <i className="ri-whatsapp-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2 sm:mb-3">Grupo VIP en WhatsApp</h3>
              <p className="text-xs sm:text-sm text-white/75">Acceso exclusivo a la comunidad</p>
            </div>

            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-t-4 border-[#006fdd] rounded-2xl p-6 sm:p-8 text-center hover:shadow-[0_0_40px_rgba(0,111,221,0.4)] hover:translate-y-[-6px] transition-all duration-300">
              <div className="w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_25px_rgba(0,111,221,0.5)]">
                <i className="ri-line-chart-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2 sm:mb-3">Proyecciones Semanales</h3>
              <p className="text-xs sm:text-sm text-white/75">Análisis y proyecciones del mercado</p>
            </div>

            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-t-4 border-[#006fdd] rounded-2xl p-6 sm:p-8 text-center hover:shadow-[0_0_40px_rgba(0,111,221,0.4)] hover:translate-y-[-6px] transition-all duration-300">
              <div className="w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_25px_rgba(0,111,221,0.5)]">
                <i className="ri-user-star-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2 sm:mb-3">Acompañamiento Semanal</h3>
              <p className="text-xs sm:text-sm text-white/75">Soporte continuo en tu proceso</p>
            </div>

            <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-t-4 border-[#006fdd] rounded-2xl p-6 sm:p-8 text-center hover:shadow-[0_0_40px_rgba(0,111,221,0.4)] hover:translate-y-[-6px] transition-all duration-300">
              <div className="w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-[0_0_25px_rgba(0,111,221,0.5)]">
                <i className="ri-team-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2 sm:mb-3">Comunidad de Traders</h3>
              <p className="text-xs sm:text-sm text-white/75">Networking con traders profesionales</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quién es David Bravo */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=dark%20professional%20trading%20office%20workspace%20with%20charts%20and%20monitors%20showing%20forex%20analysis%20minimal%20background%20with%20blue%20accent%20lighting%20clean%20modern%20setup&width=1920&height=1000&seq=david-bg-007&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/95 via-[#070B19]/92 to-[#070B19]/95"></div>
        </div>
        <div className="container mx-auto max-w-7xl relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-10 sm:mb-12 md:mb-16 px-4">
            Quién es David Bravo
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
            {/* Imagen de David */}
            <div className="flex justify-center lg:justify-end order-1 lg:order-1">
              <div className="relative w-full max-w-sm sm:max-w-md">
                <div className="absolute inset-0 bg-gradient-to-br from-[#006fdd]/30 to-[#0059b3]/30 rounded-3xl blur-2xl"></div>
                <div className="relative w-full aspect-[3/4] rounded-2xl sm:rounded-3xl overflow-hidden border-2 sm:border-4 border-[#006fdd]/40 shadow-[0_0_60px_rgba(0,111,221,0.4)]">
                  <img 
                    src="https://static.readdy.ai/image/c8868ffe10580a62b25509de68a68c25/68c9adb828fc32180f7307ad8b5342c3.jpeg"
                    alt="David Bravo"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>

            {/* Contenido de texto */}
            <div className="space-y-6 sm:space-y-8 order-2 lg:order-2">
              <div className="space-y-4 sm:space-y-6 px-2">
                <p className="text-white/90 text-sm sm:text-base md:text-lg leading-relaxed">
                  Soy David y estoy aquí para potenciar tus habilidades como trader. El trading se ha convertido en mi pasión porque no solo gano dinero, sino que también me divierto.
                </p>
                <p className="text-white/90 text-sm sm:text-base md:text-lg leading-relaxed">
                  Al interiorizar la metodología que te enseñaré, todo se simplificó. Ahora, solo espero los mejores setups y gestiono mi capital de manera impecable.
                </p>
                <p className="text-white/90 text-sm sm:text-base md:text-lg leading-relaxed">
                  Estoy listo para compartir contigo todos los secretos que me han llevado al éxito en el mercado forex. <span className="text-[#006fdd] font-semibold">¡Prepárate para transformar tus resultados!</span>
                </p>
              </div>

              {/* Habilidades destacadas */}
              <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border border-[#006fdd]/30 rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(0,111,221,0.2)]">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6">Habilidades destacadas</h3>
                
                <div className="space-y-4 sm:space-y-6">
                  {/* Superación */}
                  <div>
                    <div className="flex justify-between items-center mb-2 sm:mb-3">
                      <span className="text-sm sm:text-base text-white/90 font-medium">Superación</span>
                      <span className="text-[#006fdd] font-bold text-base sm:text-lg">85%</span>
                    </div>
                    <div className="w-full h-2 sm:h-3 bg-[#070B19] rounded-full overflow-hidden shadow-inner">
                      <div 
                        className="h-full bg-gradient-to-r from-[#006fdd] to-[#0059b3] rounded-full shadow-[0_0_15px_rgba(0,111,221,0.6)] transition-all duration-1000 ease-out"
                        style={{ width: '85%' }}
                      ></div>
                    </div>
                  </div>

                  {/* Resiliencia */}
                  <div>
                    <div className="flex justify-between items-center mb-2 sm:mb-3">
                      <span className="text-sm sm:text-base text-white/90 font-medium">Resiliencia</span>
                      <span className="text-[#006fdd] font-bold text-base sm:text-lg">82%</span>
                    </div>
                    <div className="w-full h-2 sm:h-3 bg-[#070B19] rounded-full overflow-hidden shadow-inner">
                      <div 
                        className="h-full bg-gradient-to-r from-[#006fdd] to-[#0059b3] rounded-full shadow-[0_0_15px_rgba(0,111,221,0.6)] transition-all duration-1000 ease-out"
                        style={{ width: '82%' }}
                      ></div>
                    </div>
                  </div>

                  {/* Perseverancia */}
                  <div>
                    <div className="flex justify-between items-center mb-2 sm:mb-3">
                      <span className="text-sm sm:text-base text-white/90 font-medium">Perseverancia</span>
                      <span className="text-[#006fdd] font-bold text-base sm:text-lg">90%</span>
                    </div>
                    <div className="w-full h-2 sm:h-3 bg-[#070B19] rounded-full overflow-hidden shadow-inner">
                      <div 
                        className="h-full bg-gradient-to-r from-[#006fdd] to-[#0059b3] rounded-full shadow-[0_0_15px_rgba(0,111,221,0.6)] transition-all duration-1000 ease-out"
                        style={{ width: '90%' }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Inversión */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=premium%20luxury%20trading%20investment%20concept%20with%20golden%20financial%20charts%20showing%20exponential%20profit%20growth%20and%20successful%20trades%20on%20elegant%20dark%20background%20with%20blue%20and%20gold%20highlights%20professional%20forex%20market%20success%20visualization&width=1920&height=1200&seq=pricing-bg-006&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/96 via-[#070B19]/94 to-[#070B19]/96"></div>
        </div>

        {/* Elementos decorativos */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-[#006fdd]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-[#006fdd]/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto max-w-5xl relative z-10">
          {/* Título de la sección */}
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              Inversión en Tu Futuro
            </h2>
            <p className="text-base sm:text-lg text-white/70 max-w-2xl mx-auto px-4">
              Una oportunidad única para transformar tu operativa y alcanzar la consistencia que buscas
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 sm:gap-8 items-start">
            {/* Columna izquierda - Lo que incluye */}
            <div className="lg:col-span-2 space-y-4">
              <div className="bg-gradient-to-br from-[#0d1228]/90 to-[#070B19]/90 backdrop-blur-md border border-[#006fdd]/30 rounded-2xl p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-[#006fdd] text-2xl"></i>
                  Lo que incluye
                </h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>6 módulos completos de formación profesional</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Clases en vivo + grabaciones permanentes</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Comunidad VIP exclusiva en WhatsApp</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Proyecciones y análisis semanales</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>2 indicadores profesionales incluidos</span>
                  </li>
                  <li className="flex items-start gap-3 text-sm sm:text-base text-white/85">
                    <i className="ri-check-line text-[#006fdd] text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Acompañamiento directo durante 8 semanas</span>
                  </li>
                </ul>
              </div>

              {/* Garantía */}
              <div className="bg-gradient-to-br from-[#006fdd]/20 to-[#0059b3]/20 backdrop-blur-md border border-[#006fdd]/40 rounded-xl p-5 sm:p-6">
                <div className="flex items-start gap-3">
                  <i className="ri-shield-check-fill text-[#006fdd] text-3xl flex-shrink-0"></i>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-white mb-2">Garantía de Calidad</h4>
                    <p className="text-xs sm:text-sm text-white/80 leading-relaxed">
                      Metodología probada con resultados reales. Aprende los mismos criterios que me ayudaron a ganar $47,000 en FTMO.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Columna central - Precio principal */}
            <div className="lg:col-span-3">
              <div className="relative">
                {/* Badge de oferta limitada */}
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-20">
                  <div className="bg-gradient-to-r from-[#006fdd] to-[#0059b3] px-6 py-2 rounded-full shadow-[0_0_30px_rgba(0,111,221,0.6)] animate-pulse">
                    <p className="text-xs sm:text-sm font-bold text-white whitespace-nowrap">
                      🔥 OFERTA DE LANZAMIENTO
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-xl border-2 border-[#006fdd]/60 rounded-3xl p-8 sm:p-10 md:p-12 shadow-[0_0_80px_rgba(0,111,221,0.5)] text-center mt-6">
                  {/* Precio anterior */}
                  <div className="mb-6">
                    <p className="text-white/50 text-sm sm:text-base mb-2">Precio regular:</p>
                    <p className="text-3xl sm:text-4xl text-white/40 line-through font-bold">$250</p>
                  </div>

                  {/* Precio actual */}
                  <div className="mb-8">
                    <p className="text-white/70 text-base sm:text-lg mb-3">Precio de lanzamiento:</p>
                    <div className="relative inline-block">
                      <div className="absolute inset-0 bg-gradient-to-r from-[#006fdd] to-[#0059b3] blur-2xl opacity-50"></div>
                      <div className="relative">
                        <span className="text-5xl sm:text-6xl text-white font-bold drop-shadow-[0_0_20px_rgba(0,111,221,0.8)]">$</span>
                        <span className="text-7xl sm:text-8xl md:text-9xl text-white font-extrabold drop-shadow-[0_0_40px_rgba(0,111,221,1)]">197</span>
                      </div>
                    </div>
                    <p className="text-white/60 text-sm sm:text-base mt-4">Pago único • Acceso completo</p>
                  </div>

                  {/* Ahorro */}
                  <div className="bg-gradient-to-r from-[#006fdd]/30 to-[#0059b3]/30 backdrop-blur-sm border border-[#006fdd]/50 rounded-xl px-6 py-4 mb-8 inline-block">
                    <p className="text-white font-bold text-lg sm:text-xl">
                      Ahorras <span className="text-[#006fdd] text-2xl sm:text-3xl">$53</span> hoy
                    </p>
                  </div>

                  {/* Urgencia */}
                  <div className="bg-gradient-to-r from-red-500/20 to-orange-500/20 backdrop-blur-sm border border-red-500/40 rounded-xl px-6 py-4 mb-8">
                    <div className="flex items-center justify-center gap-3 mb-2">
                      <i className="ri-alarm-warning-fill text-red-400 text-2xl"></i>
                      <p className="text-base sm:text-lg font-bold text-white">Solo quedan 7 cupos</p>
                    </div>
                    <p className="text-xs sm:text-sm text-white/70">
                      Cupo máximo: 20 traders • Ya se inscribieron 13 personas
                    </p>
                  </div>

                  {/* CTA Principal */}
                  <a 
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative inline-flex items-center justify-center gap-3 px-8 sm:px-12 py-5 sm:py-6 bg-gradient-to-r from-[#006fdd] to-[#0059b3] text-white text-lg sm:text-xl md:text-2xl font-bold rounded-full hover:scale-105 hover:shadow-[0_0_60px_rgba(0,111,221,0.8)] transition-all duration-300 whitespace-nowrap cursor-pointer mb-6 w-full sm:w-auto overflow-hidden"
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                    <i className="ri-whatsapp-line text-3xl sm:text-4xl relative z-10"></i>
                    <span className="relative z-10">Asegurar mi cupo ahora</span>
                  </a>

                  {/* Mensaje prellenado */}
                  <div className="bg-[#070B19]/60 backdrop-blur-sm border border-white/10 rounded-lg px-4 py-3">
                    <p className="text-xs text-white/50 mb-1">Mensaje automático:</p>
                    <p className="text-xs sm:text-sm text-white/70 italic leading-relaxed">
                      "hola, david. me gustaria inscribirme en la mentoría grupal de trading que empieza el 26 de enero del 2026"
                    </p>
                  </div>
                </div>

                {/* Testimonios rápidos */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
                  <div className="bg-gradient-to-br from-[#0d1228]/80 to-[#070B19]/80 backdrop-blur-md border border-[#006fdd]/20 rounded-xl p-4 text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#006fdd] mb-1">$47K</p>
                    <p className="text-xs text-white/70">Ganados en FTMO</p>
                  </div>
                  <div className="bg-gradient-to-br from-[#0d1228]/80 to-[#070B19]/80 backdrop-blur-md border border-[#006fdd]/20 rounded-xl p-4 text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#006fdd] mb-1">8 sem</p>
                    <p className="text-xs text-white/70">De mentoría intensiva</p>
                  </div>
                  <div className="bg-gradient-to-br from-[#0d1228]/80 to-[#070B19]/80 backdrop-blur-md border border-[#006fdd]/20 rounded-xl p-4 text-center">
                    <p className="text-2xl sm:text-3xl font-bold text-[#006fdd] mb-1">20</p>
                    <p className="text-xs text-white/70">Cupo máximo</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Conecta Conmigo */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=dark%20minimalist%20social%20media%20connection%20concept%20with%20abstract%20network%20lines%20and%20nodes%20on%20black%20background%20with%20subtle%20blue%20lighting%20professional%20digital%20communication%20theme%20clean%20modern%20aesthetic&width=1920&height=1000&seq=connect-bg-008&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070B19]/95 via-[#070B19]/92 to-[#070B19]/95"></div>
        </div>
        <div className="container mx-auto max-w-7xl relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6 px-4">
            Conecta Conmigo
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-white/80 text-center max-w-3xl mx-auto mb-10 sm:mb-12 md:mb-16 leading-relaxed px-4">
            Sigue mis redes oficiales para aprender más sobre trading, ver análisis diarios y mantenerte actualizado con mi contenido educativo.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 max-w-4xl mx-auto">
            {/* YouTube */}
            <a 
              href="https://www.youtube.com/@davidbravoc"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-2 border-white/10 rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:border-[#006fdd]/60 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4 sm:gap-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center flex-shrink-0 shadow-[0_0_20px_rgba(0,111,221,0.4)] group-hover:shadow-[0_0_30px_rgba(0,111,221,0.6)] transition-all duration-300">
                  <i className="ri-youtube-line text-2xl sm:text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 group-hover:text-[#006fdd] transition-colors duration-300">YouTube</h3>
                  <p className="text-xs sm:text-sm text-white/70">Contenido Educativo Diario</p>
                </div>
              </div>
            </a>

            {/* Instagram */}
            <a 
              href="https://www.instagram.com/david_bravoc/"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-2 border-white/10 rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:border-[#006fdd]/60 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4 sm:gap-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center flex-shrink-0 shadow-[0_0_20px_rgba(0,111,221,0.4)] group-hover:shadow-[0_0_30px_rgba(0,111,221,0.6)] transition-all duration-300">
                  <i className="ri-instagram-line text-2xl sm:text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 group-hover:text-[#006fdd] transition-colors duration-300">Instagram</h3>
                  <p className="text-xs sm:text-sm text-white/70">Análisis, Historias y Resultados</p>
                </div>
              </div>
            </a>

            {/* TikTok */}
            <a 
              href="https://www.tiktok.com/@david_bravoc"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-2 border-white/10 rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:border-[#006fdd]/60 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4 sm:gap-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center flex-shrink-0 shadow-[0_0_20px_rgba(0,111,221,0.4)] group-hover:shadow-[0_0_30px_rgba(0,111,221,0.6)] transition-all duration-300">
                  <i className="ri-tiktok-line text-2xl sm:text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 group-hover:text-[#006fdd] transition-colors duration-300">TikTok</h3>
                  <p className="text-xs sm:text-sm text-white/70">Videos de Trading y Mentalidad</p>
                </div>
              </div>
            </a>

            {/* WhatsApp */}
            <a 
              href="https://wa.me/593939352835"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-[#0d1228]/95 to-[#070B19]/95 backdrop-blur-md border-2 border-white/10 rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:border-[#006fdd]/60 hover:shadow-[0_0_40px_rgba(0,111,221,0.3)] transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4 sm:gap-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center flex-shrink-0 shadow-[0_0_20px_rgba(0,111,221,0.4)] group-hover:shadow-[0_0_30px_rgba(0,111,221,0.6)] transition-all duration-300">
                  <i className="ri-whatsapp-line text-2xl sm:text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2 group-hover:text-[#006fdd] transition-colors duration-300">Escríbeme por WhatsApp</h3>
                  <p className="text-xs sm:text-sm text-white/70">Atención directa para dudas e inscripciones</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#070B19] border-t border-[#006fdd]/30 py-6 sm:py-8 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
            <div className="text-white font-bold text-lg sm:text-xl">David Bravo</div>
            <p className="text-white/40 text-xs text-center">
              © 2026 Todos los derechos reservados
            </p>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#006fdd] to-[#0059b3] rounded-full flex items-center justify-center hover:scale-110 hover:shadow-[0_0_25px_rgba(0,111,221,0.6)] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl sm:text-2xl text-white"></i>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
